import { StoreObject, StoreObjectKey, StoreObjectType, NormalizationField } from './storeObject';
import { FormTemplateNormalizationField } from '../models/form-template.model';

export interface IAction {
	type: string;
	value: StoreObject;

}

export function remove(elementName: string, sectionName: string, anyOfOptionName: string): IAction {
	const obj = new StoreObject();
	obj.CurrentStoreObj = {
		FieldName: elementName,
		SectionName: sectionName,
		AnyOfOptionName: anyOfOptionName
	};
	return {
		type: 'REMOVE',
		value: obj
	};
}

export function update(value: StoreObject): IAction {
	return {
		type: 'UPDATE',
		value
	};
}

export function add(value: StoreObject): IAction {
	return {
		type: 'ADD',
		value
	};
}

export function clone(elementName: string, sectionName: string, anyOfOptionName: string): IAction {
	const obj = new StoreObject();
	obj.CurrentStoreObj = {
		FieldName: elementName,
		SectionName: sectionName,
		AnyOfOptionName: anyOfOptionName
	};
	return {
		type: 'CLONE',
		value: obj
	};
}

export function updateSchemaNameAndTitle(title: string, description: string): IAction {
	const obj = new StoreObject();
	obj.Schema = {};
	obj.Schema.title = title;
	obj.Schema.description = description;
	return {
		type: 'UpdateSchemaNameAndTitle',
		value: obj
	};
}

export function updateLastNameIndexes(lastFieldNumber: number, lastSectionNumber: number): IAction {
	const obj = new StoreObject();
	obj.Schema = {};
	obj.Schema.lastFieldNumber = lastFieldNumber;
	obj.Schema.lastSectionNumber = lastSectionNumber;
	return {
		type: 'UpdateLastNameIndexes',
		value: obj
	};
}

export function updateDefaultSchema(schema: object, uiSchema: object, formData: object = null, formTemplateNormalizationFields: FormTemplateNormalizationField[] = [], readonly: boolean = false): IAction {
	const obj = new StoreObject();
	obj.Schema = schema;
	obj.FormTemplateNormalizationFields = formTemplateNormalizationFields;
	obj.UiSchema = readonly ? {...uiSchema,  "ui:readonly": true, "ui:disabled": true } : uiSchema;
	obj.FormData = formData;

	return {
		type: 'UpdateDefaultSchema',
		value: obj
	};
}

export function move(currentStoreKey: StoreObjectKey, previewStoreKey: StoreObjectKey, storeObjType: StoreObjectType, isElementOutside: boolean): IAction {
	const obj = new StoreObject();
	obj.CurrentStoreObj = currentStoreKey;
	obj.PreviewStoreObj = previewStoreKey;
	obj.Type = storeObjType;
	obj.TargetIsRoot = isElementOutside;
	return {
		type: 'MOVE',
		value: obj
	};
}

